<template>
  <div>
    <!--begin::Advance Table Widget 10-->
    <div class="card card-custom gutter-b">
      <!--begin::Header-->
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span
            v-if="code === 'secret'"
            class="card-label font-weight-bolder text-dark"
            >短效代理订单</span
          >
          <span v-else class="card-label font-weight-bolder text-dark"
            >隧道代理订单</span
          >
          <span class="text-muted mt-3 font-weight-bold font-size-sm"
            >建议定期重置 Token，如何重置 Token，请参考说明文档</span
          >
        </h3>
        <div class="card-toolbar">
          <v-btn
            color="primary font-weight-bolder font-size-sm"
            dark
            @click="buyClick"
            >购买</v-btn
          >
          <Buy v-bind:dialog.sync="buyDialog" :code="code"></Buy>
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body py-0">
        <!--begin::Table-->
        <div class="table-responsive">
          <table
            class="table table-head-custom table-vertical-center"
            id="kt_advance_table_widget_4"
          >
            <thead>
              <tr class="text-left">
                <th class="pl-0" style="width: 30px">
                  <label class="checkbox checkbox-lg checkbox-single mr-2">
                    <input
                      type="checkbox"
                      @input="setCheck($event.target.checked)"
                    />
                    <span></span>
                  </label>
                </th>
                <th class="pl-0" style="min-width: 120px">订单号</th>
                <th style="min-width: 110px">付费内容</th>
                <th style="min-width: 110px">
                  <span class="text-primary">有效时间</span>
                  <span class="svg-icon svg-icon-sm svg-icon-primary">
                    <!--begin::Svg Icon | path:assets/media/svg/icons/Navigation/Down-2.svg-->
                    <inline-svg
                      src="/oms/media/svg/icons/Navigation/Down-2.svg"
                    ></inline-svg>
                    <!--end::Svg Icon-->
                  </span>
                </th>
                <th style="min-width: 120px">备注</th>
                <!--              <th style="min-width: 120px">状态</th>-->
                <th class="pr-0 text-right" style="min-width: 160px">动作</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, i) in fetchService(this.code)">
                <tr v-bind:key="i">
                  <td class="pl-0 py-6">
                    <label class="checkbox checkbox-lg checkbox-single">
                      <input type="checkbox" :value="i" :checked="checked" />
                      <span></span>
                    </label>
                  </td>
                  <td class="pl-0">
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item._id["$oid"] }}</span
                    >
                  </td>
                  <td>
                    <span
                      v-if="item.product.code === 'secret'"
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >短效代理</span
                    >
                    <span
                      v-else
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >隧道代理
                    </span>

                    <span
                      v-if="item.product.code === 'secret'"
                      class="text-muted font-weight-bold"
                      >IP提取数{{ item.product.ip_num }}-提取间隔{{
                        item.product.api_rate
                      }}秒</span
                    >
                    <span v-else class="text-muted font-weight-bold"
                      >每秒最大请求数{{ item.product.qps }}</span
                    >
                  </td>
                  <td>
                    <span
                      class="text-primary font-weight-bolder d-block font-size-lg"
                      >{{
                        item.date_of_expiry | parseTime("{y}/{m}/{d} {h}:{i}")
                      }}</span
                    >
                    <span
                      class="label label-lg label-inline"
                      v-bind:class="`label-light-${item.class}`"
                      >{{ item.status }}</span
                    >
                    <!--                  <span class="text-muted font-weight-bold">{{-->
                    <!--                    item.date_desc-->
                    <!--                  }}</span>-->
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.company }}</span
                    >
                    <span class="text-muted font-weight-bold">{{
                      item.company_desc
                    }}</span>
                  </td>

                  <td class="pr-1 text-right">
                    <a
                      v-if="!item.product.is_test"
                      class="btn btn-sm btn-primary font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1"
                      @click="generateRenewData(item)"
                      >续费</a
                    >
                    <a
                      class="btn btn-sm btn-success font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1"
                      @click="toGenerateApi(item)"
                      >生成API</a
                    >
                    <a
                      class="btn btn-sm font-weight-bold py-2 px-3 px-xxl-5 my-1"
                      >更多</a
                    >
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--end::Table-->
        <Renew
          v-bind:dialog.sync="renewDialog"
          :form="renewData"
          :code="code"
        ></Renew>
      </div>
      <!--end::Body-->
    </div>
    <!--end::Advance Table Widget 10-->
    <!--    <b-dd-divider></b-dd-divider>-->
    <b-pagination
      v-model="currentPage"
      :total-rows="pagination.total"
      :per-page="10"
      aria-controls="my-table"
      class="mt-3 text-right float-right"
    ></b-pagination>
  </div>
</template>

<script>
// import { getInstance } from "@/api/instance";
import Buy from "@/view/pages/pay/Buy";
import Renew from "@/view/pages/pay/Renew";
import { fetchBuyMessage } from "@/api/message";
import { mapGetters } from "vuex";
import { GET_SERVICE } from "../../../core/services/store/service.module";
export default {
  name: "OrderWidget",
  data() {
    return {
      checked: false,
      result: this.currentServices,
      renewDialog: false,
      buyDialog: false,
      buyMessage: {
        pay_channels: [],
        products: [],
        sales: [],
      },
      renewData: {
        action: "renew",
        pay_type: "weixin",
        product: { service_id: "", days: 30 },
      },
      pagination: {
        total: "",
      },
      currentPage: 1,
    };
  },
  props: {
    code: {
      type: String,
      required: true,
      default: "secret",
    },
  },
  components: {
    Buy,
    Renew,
  },
  watch: {
    currentPage: {
      handler: function () {
        this.$store
          .dispatch(GET_SERVICE, {
            $limit: 10,
            $start: this.currentPage * 10 - 10,
            "product.code": this.code,
          })
          .then((res) => {
            this.pagination.total = res.total;
          });
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["currentServices"]),
    fetchService() {
      return function (code) {
        var result = [];
        this.currentServices.forEach((res) => {
          if (res.product.code === code) {
            result.push(res);
          }
        });
        return result;
      };
    },
  },
  mounted() {
    this.$store
      .dispatch(GET_SERVICE, { $limit: 10, "product.code": this.code })
      .then((res) => {
        this.pagination.total = res.total;
      });
  },
  created() {
    if (this.$route.query.code === "secret") {
      this.buyClick();
    }
    fetchBuyMessage().then((res) => {
      this.buyMessage = res.result;
    });
  },
  methods: {
    setCheck(check) {
      if (check) {
        this.checked = check;
      } else {
        this.checked = false;
      }
    },
    buyClick() {
      this.buyDialog = true;
    },
    generateRenewData(item) {
      this.renewData.product.service_id = item._id["$oid"];
      if (this.code === "secret") {
        this.renewData.product.ip_num = item.product.ip_num;
        this.renewData.product.api_rate = item.product.api_rate;
      } else {
        this.renewData.product.qps = item.product.qps;
      }
      this.renewDialog = true;
    },
    toGenerateApi(item) {
      this.$router.push({
        path: "/oms/generate/api",
        query: { order_id: item._id["$oid"] },
      });
    },
  },
};
</script>
